module.exports = __webpack_public_path__ + "img/preview.0808e13a.webp";